import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import dayjs from 'dayjs'
import { withStyles } from '@material-ui/core/styles'
import { Button, Dialog, DialogContent, CardMedia, Card } from '@material-ui/core'
import { FiberManualRecord } from '@material-ui/icons'
import { useTranslation } from 'react-i18next'

const styles = theme => ({
  buttonRight: {
    marginRight: 10,
    marginTop: 15,
    marginLeft: 10,
  },
  buttonNavigation: {
    marginRight: 10,
    marginTop: 15,
    marginLeft: 10,
    fontWeight: 'bold',
    cursor: 'pointer'
  },
  wrapperHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start'
  },
  wrapperNavigationPanel: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  imageBanner: {
    width: '100%'
  },
  sectionTitle: {
    width: 200
  },
  sectionContent: {
    flex: 1
  },
  fieldText: {
    textAlign: 'left'
  },
  container: {
    marginTop: 74
  }
})

const StreamCard = ({
  classes,
  personId,
  interestingStreams,
  addInterestingStream,
  fetchInterestingEventsStreams,
  isLoadingInterestingStreams,
  streamers
}) => {
  const { t } = useTranslation()
  let { idStream, idStreamer } = useParams()
  useEffect(() => {
    if (interestingStreams === undefined && !isLoadingInterestingStreams && personId) {
      fetchInterestingEventsStreams()
    }
  })
  const aboutStreamRef = React.createRef()
  const aboutStreamerRef = React.createRef()
  const streamProgramRef = React.createRef()
  const forWhomRef = React.createRef()
  const afterStreamRef = React.createRef()
  const priceRef = React.createRef()
  idStream = parseInt(idStream)
  idStreamer = parseInt(idStreamer)
  const streamer = streamers.filter(item => (item.id === idStreamer))[0]
  if (!streamer) return null
  const stream = streamer.activeStreams.filter(item => (item.id === idStream))[0]
  if (!stream) return null

  const handleScrollToSection = (refToScroll) => {
    window.scrollTo({
      top: refToScroll.current.offsetTop,
      behavior: 'smooth'
    })
  }
  const renderInterestedButton = () => {
    if (!personId || !interestingStreams) return null
    const isInterestingStreams = (interestingStreams.filter(item => (item.id === stream.id)).length === 1)
    if (isInterestingStreams) return null
    return (
      <Button
        variant='contained'
        className={classes.buttonRight}
        onClick={() => { addInterestingStream(stream) }}>
        {t('TopBar:interested')}
      </Button>
    )
  }

  const payButton = () => {
    return (
      <Button
        variant='contained'
        className={classes.buttonRight}
        onClick={() => { }}>
        {t('TopBar:pay')}
      </Button>
    );
  }

  return (
    <div className={classes.container}>
      <div className={classes.wrapperHeader}>
        <img
          src={`data:image/jpeg;base64,${stream.avatarBytes}`}
          className={classes.imageBanner}
        />
        {payButton()}
        {renderInterestedButton()}
      </div>
      <div className={classes.wrapperNavigationPanel}>
        <p
          className={classes.buttonNavigation}
          onClick={() => { handleScrollToSection(aboutStreamRef) }}>
          {t('TopBar:about stream')}
        </p>
        <p
          className={classes.buttonNavigation}
          onClick={() => { handleScrollToSection(aboutStreamerRef) }}>
          {t('TopBar:about speaker')}
        </p>
        <p
          className={classes.buttonNavigation}
          onClick={() => { handleScrollToSection(streamProgramRef) }}>
          {t('TopBar:stream program')}
        </p>
        <p
          className={classes.buttonNavigation}
          onClick={() => { handleScrollToSection(forWhomRef) }}>
          {t('TopBar:for whom')}
        </p>
        <p
          className={classes.buttonNavigation}
          onClick={() => { handleScrollToSection(afterStreamRef) }}>
          {t('TopBar:after stream')}
        </p>
        <p
          className={classes.buttonNavigation}
          onClick={() => { handleScrollToSection(priceRef) }}>
          {t('Cabinet:price')}
        </p>
      </div>
      <div className={classes.wrapperHeader} ref={aboutStreamRef}>
        <div className={classes.sectionTitle}>
          <p>{t('TopBar:about stream')}</p>
        </div>
        <div className={classes.sectionContent}>
          <p className={classes.fieldText}>
            {/* {stream.description} */}
            {'Как увеличить продажи через гугл рекламу в х10 раз'}
          </p>
        </div>
      </div>
      <div className={classes.wrapperHeader} ref={aboutStreamerRef}>
        <div className={classes.sectionTitle}>
          <p>{t('TopBar:about speaker')}</p>
        </div>
        <div className={classes.sectionContent}>
          <p className={classes.fieldText}>
            {streamer.description}
          </p>
        </div>
      </div>
      <div className={classes.wrapperHeader} ref={streamProgramRef}>
        <div className={classes.sectionTitle}>
          <p>{t('TopBar:stream program')}</p>
        </div>
        <div className={classes.sectionContent}>
          <p className={classes.fieldText}>
            {'1.Мы разберем из чего состоит рекламый кабинет гугл'}
          </p>
          <p className={classes.fieldText}>
            {'2.Узнаем какие рекламные расширения бывают'}
          </p>
          <p className={classes.fieldText}>
            {'3.Создадим первую Вашу рекламу'}
          </p>
        </div>
      </div>
      <div className={classes.wrapperHeader} ref={forWhomRef}>
        <div className={classes.sectionTitle}>
          <p>{t('TopBar:for whom')}</p>
        </div>
        <div className={classes.sectionContent}>
          <p className={classes.fieldText}>
            {'Для владельцев интернет магазинов'}
          </p>
          <p className={classes.fieldText}>
            {'Для начинающих маркетологов'}
          </p>
        </div>
      </div>
      <div className={classes.wrapperHeader} ref={afterStreamRef}>
        <div className={classes.sectionTitle}>
          <p>{t('TopBar:after stream')}</p>
        </div>
        <div className={classes.sectionContent}>
          <p className={classes.fieldText}>
            {'Вы перестанете бояться создавать рекламу. Поймете, что это не страшно'}
          </p>
          <p className={classes.fieldText}>
            {'Научитесь подбирать ключевые слова'}
          </p>
          <p className={classes.fieldText}>
            {'Научитесь анализировать успешность своей рекламной кампании'}
          </p>
        </div>
      </div>
      <div className={classes.wrapperHeader} ref={priceRef}>
        <div className={classes.sectionTitle}>
          <p>{t('Cabinet:price')}</p>
        </div>
        <div className={classes.sectionContent}>
          <p className={classes.fieldText}>
            {stream.price}
          </p>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(StreamCard)
